import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  standalone: false
})
export class RatingComponent implements OnInit {


  @Input('rating') rating: number = 3;
  @Input('starCount') starCount: number = 5;
  @Input() isCourseRate = false
  @Output() ratingUpdated = new EventEmitter();

  snackBarDuration: number = 2000;
  ratingArr: any[] = [];

  constructor(private snackBar: MatSnackBar) {
  }


  ngOnInit() {
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
  }
  onClick(rating: number) {
    if (!this.isCourseRate) {
      this.snackBar.open('You rated ' + rating + ' / ' + this.starCount, '', {
        duration: this.snackBarDuration
      });
    }
    this.rating = rating
    this.ratingUpdated.emit(rating);
    return false;
  }

  // showIcon(index:number) {
  //   if (this.rating >= index + 1) {
  //     return 'star';
  //   } else {
  //     return 'star_border';
  //   }
  // }

}
export enum StarRatingColor {
  primary = "primary",
  accent = "accent",
  warn = "warn"
}

